import { Map, List, fromJS } from 'immutable';

export function request(state, { userId }) {
    state = state.setIn([ 'placeBet', userId ], Map({
        state: 'IN_PROGRESS'
    }));

    return state;
}

export function error(state, { userId, bets, combinations, possibilityError, errors }) {
    if (possibilityError) {
        state = state.setIn([ 'possibleBets', userId ], Map({
            state: 'FINISHED',
            errors: fromJS(errors)
        }));

        delete combinations['SGL'];

        state = state.setIn([ 'combinations', userId ], fromJS(combinations).toList());

        let mappedBets = {};

        bets.forEach(bet => {
            mappedBets[bet.uid] = bet;
        });

        let userBets = state.getIn([ 'bets', userId ]) || List();

        userBets = userBets.map(bet => {
            let betResult = mappedBets[bet.get('uid')];

            if (!betResult) {
                return bet;
            }

            // Price can be under 0 and then this bet is incorrect (happens for each way on events without EW)
            return bet
                .set('errors', fromJS(betResult.errors))
                .set('potentialReturns', betResult.potentialReturns)
                .set('potentialReturnsAt', betResult.stakePerLine)
                .set('freeBets', fromJS(betResult.freeBets))
                .set('price', betResult.price && betResult.price.f.charAt(0) !== '-' ? betResult.price.f : null);
        });

        state = state.setIn([ 'bets', userId ], userBets);
    }

    state = state.setIn([ 'placeBet', userId ], Map({
        state: 'ERROR',
        errors: fromJS(errors)
    }));

    return state;
}

export function finish(state, { userId, bets }) {
    return state
        .removeIn([ 'possibleBets', userId ])
        .setIn([ 'combinations', userId ], List())
        .setIn([ 'bets', userId ], List())
        .setIn([ 'legs', userId ], Map())
        .setIn([ 'multiples', userId ], Map())
        .setIn([ 'placeBet', userId ], Map({
            state: 'FINISHED',
            bets: fromJS(bets)
        }));
}

export function clear(state, { userId }) {
    return state.removeIn([ 'placeBet', userId ]);
}
